module.exports = __webpack_public_path__ + "img/info_circle.cf6a5a9a.svg";